class Tag {

	static fromArray(data, list) {
		let inst = new Tag(list);
		inst.id = data._id;
		inst.name = data._name;
		inst.color = data.color;
		inst.orderBy = data.orderBy;
		return inst.init();
	}

	static blank(list) {
		let inst = new Tag(list);
		inst.name = _("New Tag");
		inst.color = null;
		inst.orderBy = list._editList.length + 1;
		return inst.init();
	}

	constructor (list) {
		this._id = 0;
		this._name = null;
		this._color = null;
		this._orderBy = null;
		this._list = list;
		
		this._chkBox = UI.chk();
		onEv(this._chkBox, 'change', () => {
			this._list._itemList.toggleTag(this);
		});
	}

	init() {
		this._rowElem = UI.listPlace([
			this._dragElem = UI.listRow([
				UI.div('drag-handle', null, {
					'mousedown touchstart': this.prepDrag.bind(this)
				}),
				UI.div('edit-show flex-1', [
					this._nameEdit = UI.text(''),
				]),
				UI.div('edit-hide flex-1', [
					this._nameView = UI.span('', this._name),
				]),
				UI.div('flex-0 edit-show', [
					UI.btn('', _("SAVE"), {'click': this.save.bind(this)}),
					UI.btn('', _("CANCEL"), {'click': this.cancel.bind(this)}),
				]),
				UI.div('flex-0 edit-hide', [
					UI.priIconBtn('edit', 18, {'click': this.edit.bind(this)}),
					UI.priIconBtn('delete', 18, {'click': this.delete.bind(this)})
				])
			])
		]);

		this._chkElem = UI.div('absolute px-3', [
			UI.label([
				this._chkBox,
				this._nameView2 = UI.span('edit-hide ps-3', this._name),
			])
		]);
		return this;
	}

	get id() {return this._id;} 
	set id(v) {this._id = v;}

	get name() {return this._name;}
	set name(v) {this._name = v;}

	get color() {return this._color;}
	set color(v) {this._color = v;}

	get orderBy() {return this._orderBy;}
	set orderBy(v) {this._orderBy = v;}

	get rowElem() {return this._rowElem;}
	get dragElem() {return this._dragElem;}
	get chkElem() {return this._chkElem;}

	get isSet() {return this._chkBox.checked;}
	set isSet(v) {this._chkBox.checked = !!v;}

	reset() {
		this.count = 0;
		this._chkBox.checked = false;
		this._chkBox.indeterminate = false;
	}

	increment(max) {
		this.count++;
		this._chkBox.checked = this.count > 0;
		this._chkBox.indeterminate = this.count < max;
	}

	prepDrag(ev) {
		this._list.prepDrag(this, ev);
	}

	clicked() {}

	dropped() {
		this.orderBy = this._list._editList.position;
		API.upsert(
			'tags',
			this.id,
			{ orderBy: this.orderBy }
		)
		.then( reply => {
			this._list._checkList.sort();
			showError(reply);
		});
	}

	edit() {
		if (this._list._activeTag) return;
		this._list._activeTag = this;
		this._nameEdit.value = this._name;
		Dialog.Inline(this._dragElem, this);
		this._nameEdit.select();
	}

	save() {
		if (this._nameEdit.value.length) this._name = this._nameEdit.value;
		this._nameView.innerHTML = this._nameView2.innerHTML = this._name;

		API.upsert(
			'tags',
			this.id,
			{
				name: this.name,
				orderBy: this._orderBy
			}
		)
		.then(reply => {
			showError(reply);
			if(reply.id) this.id = reply.id;
			if(this._list._selectionIds) {
				this._chkBox.checked = true;
				this.toggleSelect();
			}
			if (this._list._activeTag) this.finish();
			document.dispatchEvent(new Event('filtersChanged'));
		});
	}
	
	cancel() {
		this.finish();
		if (this._id === 0) this._list.remove(this);
	}

	finish() {
		Dialog.Inline(this._dragElem);
		this._list._activeTag = null;
	}

	delete() {
		API.delete(
			'tags',
			{
				id: this.id
			}
		)
		.then(reply => {
			if (showError(reply)) return;
			this._list.remove(this);
			document.dispatchEvent(new Event('filtersChanged'));
		});
	}
}